import createStore from "@/utils/create-store";
import Model from "@/models/admin/ads";

export default createStore({ Model });
